export const pushAndroidChannel = {
  id: "bhadapms_notifications",
  name: "BhadaPMS Notifications",
  importance: 5, // MAX importance for heads-up (pop-over) notifications on Android
  visibility: 1, // Public visibility
};